@if (magicSearchService.isSearching()) {
<div class="w-full h-full overflow-hidden min-h-0 scrollbar-hide text-primary">
    <om-flickering-grid [squareSize]="10">
        <div class="content">
            <div class="text-center">
                <div class="mx-auto size-36">
                    <om-orb>
                        <div class="content">

                        </div>
                    </om-orb>
                </div>


                <h3 class="mt-2 text-md font-semibold text-white">Searching...</h3>
                <om-typewriter
                    [words]="['Scanning creators...', 'Analysing content styles...', 'Checking engagement rates...', 'Filtering by your brief...', 'Shortlisting top matches...', 'Almost there...']"
                    [writeDelay]="100" [writeSpeed]="30" styleClass="typewriter-large"></om-typewriter>
            </div>

        </div>
    </om-flickering-grid>
</div>
}


<!-- Pink Search Results -->
@if (magicSearchService.pinkSearchResults() && magicSearchService.pinkSearchResults()!.length > 0) {
<div class="w-full h-full overflow-y-auto min-h-0 scrollbar-hide">

    <div class="w-full">
        <ul role="list" class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
            @for (creator of magicSearchService.pinkSearchResults()!; track $index) {
            <li class="card-animate" [style.animation-delay]="($index * 0.1) + 's'">
                <cv2-creator-card-pink [creator]="creator"></cv2-creator-card-pink>
            </li>
            }
        </ul>
    </div>
</div>
}
<!-- Pink Search Results - END -->

<!-- Blue Search Results -->
@if (magicSearchService.blueSearchResults() && magicSearchService.blueSearchResults()!.length > 0) {
<div class="w-full h-full overflow-y-auto min-h-0 scrollbar-hide">
    <ul role="list" class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
        @for (creator of magicSearchService.blueSearchResults()!; track $index) {
        <li class="card-animate" [style.animation-delay]="($index * 0.1) + 's'">
            <creator-card-blue [creator]="creator"></creator-card-blue>
        </li>
        }
    </ul>
</div>
}
<!-- Blue Search Results - END -->

<!-- Purple Search Results -->
@if (magicSearchService.purpleSearchResults() && magicSearchService.purpleSearchResults()!.length > 0) {
<div class="w-full h-full overflow-y-auto min-h-0 scrollbar-hide">
    <ul role="list" class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        @for (creator of magicSearchService.purpleSearchResults()!; track $index) {
        <li class="card-animate" [style.animation-delay]="($index * 0.1) + 's'">
            <cv2-creator-card-purple [creator]="creator"></cv2-creator-card-purple>
        </li>
        }
    </ul>
</div>
}
<!-- Purple Search Results - END -->

<!-- No search results -->
@if (!magicSearchService.isSearching() && !magicSearchService.pinkSearchResults() && !magicSearchService.blueSearchResults() && !magicSearchService.purpleSearchResults()) {
<div class="w-full h-full flex items-center justify-center p-8">
    <div class="max-w-2xl text-center">
        <div class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/15 mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-10 text-accent">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
            </svg>
        </div>
        <h2 class="text-2xl font-semibold text-primary mb-4">Describe the creator you're looking for</h2>
        <p class="text-base text-secondary leading-relaxed mb-6">
            Use your own language to describe the creator persona you want to find. When you type a query, we'll search through creator content and find creators who have made videos that represent what you've asked for.
        </p>
        <div class="mt-8 space-y-3 text-left max-w-md mx-auto">
            <div class="flex items-start gap-3">
                <div class="flex-shrink-0 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="text-accent">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                        <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                </div>
                <p class="text-sm text-secondary">
                    <span class="font-semibold text-primary">Natural language search:</span> Describe creators in your own words - no need for specific keywords or filters.
                </p>
            </div>
            <div class="flex items-start gap-3">
                <div class="flex-shrink-0 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="text-accent">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                        <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                </div>
                <p class="text-sm text-secondary">
                    <span class="font-semibold text-primary">Video-based matching:</span> We analyze creator videos to find matches based on content, style, and themes.
                </p>
            </div>
            <div class="flex items-start gap-3">
                <div class="flex-shrink-0 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="text-accent">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                        <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                </div>
                <p class="text-sm text-secondary">
                    <span class="font-semibold text-primary">Smart results:</span> Get creators whose video content aligns with your description and requirements.
                </p>
            </div>
        </div>
    </div>
</div>
}
<!-- No search results - END -->